















































































import mixins from 'vue-typed-mixins';
import { ReversalReason } from './ReversalReason';
import LocationBasedMixin from '@/Shared/LocationBasedMixin';
import BuildEntityListComponentMixin from '@/Shared/CommonEntityMixins/EntityListComponentMixin';
import { AxiosResponse } from 'axios';
import VatsAPI from '@/Shared/VatsAPI';

const component = mixins(LocationBasedMixin, BuildEntityListComponentMixin<ReversalReason>()).extend({
    data() {
        return {
            i18nPrefix: 'admin.ReversalReasonManagement',
        };
    },
    computed: {
        entityUrls(): string {
            return `${this.location}/ReversalReason/Reversal`;
        }
    },
    methods: {
        async saveReversal(entity: ReversalReason) {
            if (this.editItem?.recID != null) {
                const url = `/${this.location}/reversalreason/update`;
                await VatsAPI.post<ReversalReason>(url, entity);
            }
            else {
                await this.saveEntity(entity);
            }
            await this.loadEntities();
            this.cancelEdit();
        },
    },
    filters: {
        formatPayment(value: string) {
            if (!value) {
                return '0.00';
            }
            return parseFloat(value).toFixed(2);
        }
    },
});

export default component;
